const mapping: Record<string, string> = {
  id: 'a=>a.Id',
  name: 'a=>a.Name',
  description: 'a=>a.Description',
}

export const mapSortAccessParam = (key: string) => mapping[key]
